import $ from 'jquery'

$(document).ready(function() {
	let wrapper = $('.slideshow-wrapper')
	wrapper.each(function() {
		$(this).slick({
			dots: true,
			autoplay: true,
			arrows: false,
			infinite: true,
			speed: 500,
			autoplaySpeed: 4000,
			fade: true
		})
	})
})
